import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import Homepage from './components/Homepage'
import Playground from './components/Playground'
import SingleStoryPage from './components/SingleStoryPage'
import StoriesPage from './components/StoriesPage'

const App: React.FC = () => {
	return (
		<div className="App">
			<BrowserRouter>
				<Switch>
					<Route path="/" exact component={Homepage} />
					<Route path="/stories" exact component={StoriesPage} />
					<Route
						path="/stories/:id"
						exact
						component={SingleStoryPage}
					/>
					<Route path="/playground" exact component={Playground} />
				</Switch>
			</BrowserRouter>
		</div>
	)
}

export default App
